import Tab from '@mui/material/Tab';
import { tabStyle } from 'common/components/AppLayout/AppLayout.styles';
import { usePreviousPath } from 'common/components/AppLayout/AppNavigation/usePreviousPath';
import { Link, useParams } from 'react-router';
import { Routes } from 'src/Routes.constants';

import { TabsContainer } from 'src/common/components/AppLayout/Components/TabsContainer';
import { a11yTabProps } from 'src/common/components/AppLayout/Components/utils';
import { useTranslation } from 'react-i18next';
import { useAuditTrailAvailable } from 'src/auditTrail/hooks/useAuditTrailAvailable';
import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';

export const SimProfilesDetailsTabsLayout = ({
  children,
  additionalTopMargin = 0,
}: {
  children: React.ReactNode;
  additionalTopMargin?: number;
}) => {
  const { t } = useTranslation();
  const { iccid } = useParams();
  const previousPath = usePreviousPath();

  const locationEnabled = useHasFeatureFlag('Locations');
  const auditTrailEnabled = useAuditTrailAvailable();

  return (
    <TabsContainer content={children} additionalTopMargin={additionalTopMargin}>
      <Tab
        value={`${Routes.simInventory}/${iccid}`}
        label={t('simInventory.details.tabs.general')}
        component={Link}
        to={`${Routes.simInventory}/${iccid}`}
        state={{ previousPath }}
        sx={tabStyle}
        {...a11yTabProps(t('simInventory.details.tabs.general'))}
        replace
      />
      {locationEnabled ? (
        <Tab
          value={`${Routes.simInventory}/${iccid}/location`}
          label={t('simInventory.details.tabs.location')}
          component={Link}
          to={`${Routes.simInventory}/${iccid}/location`}
          state={{ previousPath }}
          sx={tabStyle}
          {...a11yTabProps(t('simInventory.details.tabs.location'))}
          replace
        />
      ) : null}
      <Tab
        value={`${Routes.simInventory}/${iccid}/history`}
        label={t('simInventory.details.tabs.history')}
        component={Link}
        to={`${Routes.simInventory}/${iccid}/history`}
        state={{ previousPath }}
        sx={tabStyle}
        {...a11yTabProps(t('simInventory.details.tabs.history'))}
        replace
      />
      <Tab
        value={`${Routes.simInventory}/${iccid}/history-analysis`}
        label={t('simInventory.details.tabs.historyAnalysis')}
        component={Link}
        to={`${Routes.simInventory}/${iccid}/history-analysis`}
        state={{ previousPath }}
        sx={tabStyle}
        {...a11yTabProps(t('simInventory.details.tabs.historyAnalysis'))}
        replace
      />
      {auditTrailEnabled ? (
        <Tab
          value={`${Routes.simInventory}/${iccid}/audit-trail`}
          label={t('simInventory.details.tabs.auditTrail')}
          component={Link}
          to={`${Routes.simInventory}/${iccid}/audit-trail`}
          state={{ previousPath }}
          sx={tabStyle}
          {...a11yTabProps(t('simInventory.details.tabs.auditTrail'))}
          replace
        />
      ) : null}
    </TabsContainer>
  );
};
